/* eslint-disable camelcase */
const ajustarControleAcesso = (operacao) => {
  const { idoperacao_str } = operacao
  return { idoperacao: idoperacao_str }
}

export default ajustarControleAcesso
